const routes = [
    {
        path: '/systemPages',
        component: () => import('@/pages/systemPage/SystemPageHome.vue'),
        meta: { breadCrumb: 'System Pages', entity: 'systemPage' },
        children: [
            {
                path: '',
                name: 'systemPages',
                component: () => import('@/pages/systemPage/SystemPageList.vue'),
            },
            {
                path: 'new',
                name: 'newSystemPage',
                component: () => import('@/pages/systemPage/Editor.vue'),
                meta: { breadCrumb: 'New' },
            },
            {
                path: ':id/edit',
                name: 'editSystemPage',
                component: () => import('@/pages/systemPage/Editor.vue'),
                props: true,
                meta: { breadCrumb: 'Edit' },
            },
            {
                path: ':id/:tabName?',
                name: 'readSystemPage',
                component: () => import('@/pages/systemPage/SystemPageReader.vue'),
                props: true,
                meta: { breadCrumb: 'Read' },
            },
        ],
    },
]

export default routes
